var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "moon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h10v10H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#moon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.741.841a3.125 3.125 0 1 0 4.417 4.417A4.167 4.167 0 1 1 4.741.841"
}))));
export { SvgMoon as ReactComponent };
export default __webpack_public_path__ + "151f3eb1ae1f2b9f0a834077c349d25a.svg";